import { BaseParameterDto } from './base-parameter-dto';

export class AttachmentParameterDto extends BaseParameterDto {
    fileName: string;
    attachmentBase64: string;
}
